import * as React from 'react';
import {
  TouchableOpacity,
  View,
  StyleSheet,
  Text,
  Dimensions,
} from 'react-native';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import Styles from '../../Styles';
import type {MenuCategoryType, MenuProductType} from 'src/types/Menu';
import SearchProduct from '../../elements/cart/SearchProduct';
type SubMenuProps = {
  menu: MenuCategoryType;
  onProductPress: (product: MenuProductType) => void;
};
const imageHeight = Dimensions.get('screen').height * 0.2;
export default function SubMenu({menu, onProductPress}: SubMenuProps) {
  const count = menu.products?.length ?? 0;
  const [selected, setSelected] = React.useState(false);

  const onPress = () => setSelected(!selected);

  const icon = selected ? 'chevron-up' : 'chevron-down';
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={styles.container}>
        <View style={styles.menuContent}>
          <View style={styles.bar} />
          <View style={styles.cellContent}>
            <View style={styles.mainCellContent}>
              <Text style={styles.productName}>{menu.longname}</Text>
              <Text style={styles.productPrice}>{`(${count})`}</Text>
            </View>
            <TouchableOpacity onPress={onPress}>
              <FontAwesome5Pro
                name={icon}
                color={Styles.primaryColor}
                size={Styles.Fonts.f2}
                light
              />
            </TouchableOpacity>
          </View>
        </View>
        {selected &&
          menu.products?.map((product) => (
            <SearchProduct
              onPress={() => onProductPress(product)}
              name={product.name}
              price={parseFloat(product.price)}
            />
          ))}
      </View>
    </TouchableOpacity>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  menuContent: {
    flexDirection: 'row',
    borderBottomColor: Styles.bgColor,
    borderBottomWidth: 1,
  },
  cellContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: Styles.Spacing.m2,
    paddingLeft: Styles.Spacing.m3 - Styles.Spacing.m1,
    paddingRight: Styles.Spacing.m3,
  },
  bar: {
    backgroundColor: Styles.primaryColor,
    alignSelf: 'stretch',
    width: Styles.Spacing.m1,
  },
  mainCellContent: {
    flex: 1,
    justifyContent: 'space-between',
  },
  productName: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '600',
  },
  productPrice: {
    fontSize: Styles.Fonts.f0,
    color: Styles.gray40,
  },
  productImage: {
    resizeMode: 'contain',
    height: imageHeight,
    width: undefined,
  },
  imageContainer: {
    backgroundColor: Styles.imageBackground,
    width: '100%',
  },
});
